export default __webpack_public_path__ + "static/media/demo_hitachi.1b1b4e97.png";